import type { Continuity, Item } from '@dissidium/contracts';
import { itemDefinition, kitTemplateIdOf, type Slot } from '../../sim/src/items/index.ts';

export function projectEquipmentSlots(continuity: Continuity, personId: string): {
  equipped: Record<Slot, Item | null>;
  carried: Item[];
} {
  const person = continuity.persons[personId];
  const slots: Record<Slot, Item | null> = {
    'main-hand': null,
    'off-hand': null,
    'body': null,
    'belt': null,
    'pack': null,
  };
  const carried: Item[] = [];

  if (!person) {
    return { equipped: slots, carried };
  }

  const equippedSet = new Set(person.current.equipment);
  const items = Object.values(continuity.items).filter(
    it => it.allocation.kind === 'person' && it.allocation.id === personId,
  );

  for (const item of items) {
    if (equippedSet.has(item.id)) {
      const template = kitTemplateIdOf(item);
      if (template) {
        const def = itemDefinition(template);
        if (def.slot) {
          slots[def.slot] = item;
        }
      }
    } else {
      carried.push(item);
    }
  }

  return { equipped: slots, carried };
}
